import { ENTITY_PROFILE_TABS_LOADING_TAB_WIDTHS } from './EntityProfileTabsLoading.constants'

export function getEntityProfileTabsLoadingTabWidth(index) {
  return ENTITY_PROFILE_TABS_LOADING_TAB_WIDTHS[
    index % ENTITY_PROFILE_TABS_LOADING_TAB_WIDTHS.length
  ]
}
